import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { CheckboxOptionModel } from '../../Forms/models/checkbox-option.model';

export class CheckboxFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    option: CheckboxOptionModel;
    binary?: boolean;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        option: CheckboxOptionModel,
        binary?: boolean
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.option = option;
        this.binary = !!binary;
    }
}
